enum userTypes {
    Artist = "Artist",
    User = "User",
    Guest = "Guest",
}

export default userTypes;
